import { useCallback } from 'react';
import { prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '@core/js/store/hooks';
import { TDepositResponse, TWithdrawResponse } from '@core/js/hooks/socket/types';
import { showCommonPopupAction } from '@core/js/components/common/popups/CommonPopup';

export const useHandleCashierNotification = () => {
    const dispatch = useDispatch();
    const sendCashierMessagesToGS = useAppSelector(prop('sendCashierMessagesToGS'));

    return useCallback((response: TDepositResponse | TWithdrawResponse): void => {
        const { ID, data } = response || {};
        const isDepositResponse = ID === 33015;

        if (isDepositResponse && sendCashierMessagesToGS) {
            return;
        }

        data.payments?.transaction?.forEach((transaction) => {
            dispatch(showCommonPopupAction({
                content: transaction.message,
                title: `playtech.mobile.system.mobile-cashier.${isDepositResponse ? 'deposit' : 'withdraw'}.title`,
                // @ts-expect-error showCommonPopupAction is in JS file
                className: 'cms-cashier-notification__popup' // @theme
            }));
        });
    }, [dispatch, sendCashierMessagesToGS]);
};
